import i18nFactory from '@yandex-int/i18n';

import { mapStringToCurrencySymbol } from '../../../mappers/common/common';
import { CampaignType } from '../../../typings/domain';
import {
    EditGroupDataValue,
    EditInternalGroupDataValue,
    EditPerformanceGroupDataValue,
    EditTextGroupDataValue
} from '../../../typings/groupsEditState';
import { formatNumber } from '../../FormatHelpers/FormatHelpers';
import {
    ClientErrorsConfigRule,
    EditGroupValidationParams
} from '../ClientGroupEditErrors/ClientGroupEditErrors';
import { GroupValidationSchema } from '../GroupValidationSchema/GroupValidationSchema';

import * as keyset from './ExternalGroupValidationSchema.i18n';

const i18n = i18nFactory(keyset);

type ClientErrorGroupKeys = EditTextGroupDataValue &
    EditPerformanceGroupDataValue &
    EditInternalGroupDataValue;

interface ClientErrorGroupRules<K extends keyof ClientErrorGroupKeys> {
    rules: Array<ClientErrorsConfigRule<K>>;
}

export class ExternalGroupValidationSchema extends GroupValidationSchema {
    protected getClientErrorsConfig(
        params: EditGroupValidationParams
    ): Partial<
        { [T in keyof ClientErrorGroupKeys]: ClientErrorGroupRules<T> }
    > {
        return {
            feedId: {
                rules: [
                    {
                        code: 'required',
                        validate: (value: string): boolean => {
                            return Boolean(value);
                        },
                        needToValidate: (
                            group: EditGroupDataValue
                        ): boolean => {
                            return (
                                group.campaignType === CampaignType.PERFORMANCE
                            );
                        },
                        text: i18n('feed-required')
                    }
                ]
            },
            name: {
                rules: [
                    {
                        code: 'required',
                        validate: (value: string): boolean => {
                            return value.trim() !== '';
                        },
                        text: i18n('name-empty')
                    }
                ]
            },
            generalRate: {
                rules: [
                    {
                        code: 'maxValue',
                        validate: (value: number): boolean => {
                            return value <= params.maxGeneralPrice;
                        },
                        needToValidate: (
                            group: EditGroupDataValue,
                            value: number
                        ): boolean => {
                            return (
                                (CampaignType.TEXT === group.campaignType ||
                                    CampaignType.CPM_BANNER ===
                                        group.campaignType) &&
                                value !== undefined
                            );
                        },
                        text: i18n('general-rate-max-price', {
                            maxValue: formatNumber(params.maxGeneralPrice),
                            currency: mapStringToCurrencySymbol(params.currency)
                        })
                    },
                    {
                        code: 'minValue',
                        validate: (value: number): boolean => {
                            return value >= params.minGeneralPrice;
                        },
                        needToValidate: (
                            group: EditGroupDataValue,
                            value: number
                        ): boolean => {
                            return (
                                (CampaignType.TEXT === group.campaignType ||
                                    CampaignType.CPM_BANNER ===
                                        group.campaignType) &&
                                value !== undefined
                            );
                        },
                        text: i18n('general-rate-min-price', {
                            minValue: formatNumber(params.minGeneralPrice),
                            currency: mapStringToCurrencySymbol(params.currency)
                        })
                    }
                ]
            }
        };
    }
}
